import { useEffect, useCallback, useState } from 'react';
import { LocalParticipant, VideoPresets } from 'livekit-client';

interface QualityPreset {
  width: number;
  height: number;
  maxBitrate: number;
}

const QUALITY_HIGH: QualityPreset = { width: 1280, height: 720, maxBitrate: 1_500_000 };
const QUALITY_MEDIUM: QualityPreset = { width: 854, height: 480, maxBitrate: 800_000 };

/**
 * Automatically adjusts video quality based on participant count.
 * <= 4 participants: 720p @ 1.5 Mbps
 * 5-8 participants: 480p @ 800 Kbps
 */
export function useAdaptiveQuality(participantCount: number) {
  const [currentPreset, setCurrentPreset] = useState<QualityPreset>(QUALITY_HIGH);

  useEffect(() => {
    const preset = participantCount <= 4 ? QUALITY_HIGH : QUALITY_MEDIUM;
    setCurrentPreset(preset);
  }, [participantCount]);

  const getVideoConstraints = useCallback(() => ({
    resolution: {
      width: currentPreset.width,
      height: currentPreset.height,
      frameRate: 30,
    },
  }), [currentPreset]);

  return { currentPreset, getVideoConstraints };
}
